// Pide el QR de acceso al recinto y maneja el estado del modal que lo muestra.
//
// Quién puede y cuándo lo decide el backend, no esta pantalla: un vecino necesita una
// inscripción vigente y que hoy ya haya abierto su ventana (30 min antes de la clase,
// hasta el fin del día); los roles con
// «Acceso al torniquete» tienen ventana permanente. Fuera de eso responde 403 y aquí
// solo se muestra lo que dijo.
import { useCallback, useState } from 'react';
import Acceso from '../service/Acceso';

export default function useQRAcceso() {
  const [abierto, setAbierto] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState(null);
  const [errorStatus, setErrorStatus] = useState(null);

  const generar = useCallback(async () => {
    setAbierto(true);
    setCargando(true);
    setError(null);
    setErrorStatus(null);
    setDatos(null);
    try {
      setDatos(await Acceso.GenerarQR());
    } catch (e) {
      setError(e?.message || 'No se pudo generar el QR');
      setErrorStatus(e?.status || null);
    } finally {
      setCargando(false);
    }
  }, []);

  const cerrar = useCallback(() => setAbierto(false), []);

  return {
    generar,
    // Props listas para <QRAccesoModal {...modalProps} />
    modalProps: { open: abierto, onClose: cerrar, loading: cargando, error, errorStatus, data: datos, onRegenerar: generar },
  };
}
